import { Component, OnInit, Input } from '@angular/core';
import { ScriptingProperty } from '../cpq-scripting.model';
import { ScriptingService } from '../cpq-scripting.service';

@Component({
    selector: 'cpq-scripting-property',
    templateUrl: './cpq-scripting-property.component.html',
    styleUrls: ['./cpq-scripting-property.component.scss'],
    providers: [ScriptingService],
    standalone: false
})
export class CpqScriptingPropertyComponent implements OnInit {

  @Input('properties') properties: Array<ScriptingProperty>;

  constructor(private scriptingService: ScriptingService) { }

  ngOnInit() {
  }

  toggleChildrenVisibility(property: ScriptingProperty) {
    if (property.isCollapsed) {
      if (property.propertiesAndFunctions.length === 0 && !property.isPrimitive) {
        this.scriptingService.GetProperties(property.type, property.assemblyName).subscribe(result => {
        result.propertiesAndFunctions.forEach(child => {
            child.isCollapsed = true;
          });
          property.propertiesAndFunctions = result.propertiesAndFunctions;
        });
      }
      property.isCollapsed = false;
    } else {
      property.isCollapsed = true;
    }
  }

}
